/**
 * How every IELTS and SAT section marks a choice: ink, as in the regular exam
 * (lime is kept for the one main action on a screen). Kept in one place so
 * Listening, Reading, Speaking and SAT cannot drift apart.
 */

/** A chosen answer option: ink border and a soft ink halo. */
export const SELECTED_OPTION = 'border-gray-900 bg-gray-50 shadow-[0_0_0_3px_rgba(17,24,39,0.08)]';

/** The letter or mark inside a chosen option. */
export const SELECTED_MARK = 'border-gray-900 bg-gray-900 text-white';

/** An answered question in a navigator or progress strip. */
export const ANSWERED = 'border-gray-900 bg-gray-900 text-white';

/** The question the candidate is on (takes precedence over answered, as in the regular exam's palette). */
export const CURRENT = 'border-2 border-gray-900 bg-white text-gray-900';

/** The open part or task tab, and a switched-on tool toggle. */
export const ACTIVE = 'border-gray-900 bg-gray-900 text-white';
